import { IModel, Model } from "./Model";
import { defaultTo } from "lodash";

export interface IFollowUpTypeModel extends IModel {
    followUpTypeId: number;
    name: string;
    isForTextMessages: boolean;
    isForCallInteractions: boolean;
    isForVisits: boolean;
}

export class FollowUpTypeModel extends Model implements Record<keyof IFollowUpTypeModel, any> {
    followUpTypeId: number;
    name: string;
    isForTextMessages: boolean;
    isForCallInteractions: boolean;
    isForVisits: boolean;

    constructor(params: IFollowUpTypeModel) {
        super(params);
        this.followUpTypeId = defaultTo(params.followUpTypeId, 0);
        this.name = defaultTo(params.name, "");
        this.isForTextMessages = params.isForTextMessages;
        this.isForCallInteractions = params.isForCallInteractions;
        this.isForVisits = params.isForVisits;
    }

    static defaultFollowUpType: FollowUpTypeModel = {
        followUpTypeId: 1,
        name: "No Follow Up",
        isForTextMessages: false,
        isForCallInteractions: true,
        isForVisits: true,
        rowVersion: ""
    }
}
